import { axiosInstance } from "@/axios/axiosInstance";
import { Ingredient } from "@/types/ingredient";
import { PaginatedResponse, QueryParamsBase } from "@/types/types";

export const getIngredients = async (
  params?: QueryParamsBase & { pageSize?: number; select?: string[] },
): Promise<PaginatedResponse<Ingredient>> => {
  const { data } = await axiosInstance.get(`/ingredients`, {
    params,
  });
  return data;
};

//store
export async function createIngredient(values: Ingredient) {
  const { data } = await axiosInstance.post(`/ingredients`, values);
  return data;
}

//update
export async function updateIngredient(values: Ingredient) {
  const { data } = await axiosInstance.put(`/ingredients/${values.id}`, values);
  return data;
}

//update
export async function deleteIngredient(id: Ingredient["id"]) {
  const { data } = await axiosInstance.delete(`/ingredients/${id}`);
  return data;
}

export async function restockIngredient(id: Ingredient["id"], quantity: number) {
  const { data } = await axiosInstance.post(`/ingredients/${id}/restock`, { quantity });
  return data;
}
